export const isFirstPage = (index: number): boolean => index === 0;

export const isLastPage = (index: number, totalCount: number): boolean => index === totalCount - 1;

export const formatPagerStateView = (index: number, totalCount: number): string => `${index + 1} / ${totalCount}`;
